














































import { Component, Vue } from 'vue-property-decorator';
import Button from '@/components/Button.vue';

@Component({
  components: {
    Button,
  },

})

export default class Modal extends Vue {
  next = false

  toggleNext() {
    if (this.next === false) {
      this.next = !this.next;
    } else {
      this.$router.push('/bussinesaccount/bussinesinformation');
    }
  }

  close() {
    this.$emit('modal', false);
  }
}
